export const isDevEnvironment = [
  "localhost",
  "10.0.2.2",
  "appdev.forthwithlife.co.uk",
  "appdev.sportsbloodtests.co.uk",
  "appdev.biomarkertracking.com",
  "apppreproduction.forthwithlife.co.uk",
  "apppreproduction.sportsbloodtests.co.uk",
  "apppreproduction.biomarkertracking.com",
  "devbuild.forthwithlife.co.uk",
  "devbuild.sportsbloodtests.co.uk",
  "devbuild.biomarkertracking.com",
].some(hostname => hostname == window.location.hostname);
